import { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { EnterpriseContext } from "./EnterpriseContext";
import MonthlyCompanyStatsInnerComponent from "./MonthlyCompanyStatsInnerComponent";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import truckyService from "../../common/services/trucky-service";
import VTCMenu from "../../web/components/VTCMenu";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import classNames from "classnames";
import AllTimeCompanyStats from "./AllTimeCompanyStats";
import CompanyMemberStats from "./CompanyMemberStats";
import VehicleStats from "./VehicleStats";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MonthlyCompanyStats = ({ container }) => {
  const { globalContext } = useContext(EnterpriseContext);

  const company = globalContext.company;

  const [currentTab, setCurrentTab] = useState("overall");

  useEffect(() => {
    truckyService.setDocumentTitle("Company Stats");
  }, []);

  const [period, setPeriod] = useState("monthly");

  return (
    <>
      <Row noGutters className="" id="enterpriseContainer">
        <VTCMenu active="/stats" container={container}></VTCMenu>
        <Col>
          <Row noGutters>
            <Col>
              <Card>
                <CardBody>
                  <Breadcrumbs
                    breadcrumbs={[
                      {
                        to: "/vtchub",
                        title: container.localeManager.strings.vtcHub,
                      },
                      {
                        title: container.localeManager.strings.statistics,
                      },
                    ]}
                  ></Breadcrumbs>
                  <div className="page-hero mb-4">
                    <span className="page-hero-icon">
                      <FontAwesomeIcon icon="chart-line" className="mx-0" />
                    </span>
                    <div className="flex-1">
                      <h1 className="page-hero-title mb-0">{container.localeManager.strings.statistics}</h1>
                    </div>
                  </div>

                  <Nav
                    className="nav-custom nav-line-tabs nav-line-tabs-2x fs-6 fw-bold mb-3"
                    tabs
                  >
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "overall",
                        })}
                        onClick={() => {
                          setCurrentTab("overall");
                        }}
                      >
                        <FontAwesomeIcon icon="infinity" className="me-2" />
                        {container.localeManager.strings.alltime}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "period",
                        })}
                        onClick={() => {
                          setCurrentTab("period");
                        }}
                      >
                        <FontAwesomeIcon icon="calendar-days" className="me-2" />
                        {container.localeManager.strings.periodStats}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "members",
                        })}
                        onClick={() => {
                          setCurrentTab("members");
                        }}
                      >
                        <FontAwesomeIcon icon="users" className="me-2" />
                        {container.localeManager.strings.members}
                      </NavLink>
                    </NavItem>
                    {(company.company_type == 'realistic' || company.company_type == 'both') && (
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "vehicles",
                        })}
                        onClick={() => {
                          setCurrentTab("vehicles");
                        }}
                      >
                        <FontAwesomeIcon icon="truck" className="me-2" />
                        {container.localeManager.strings.vehicles}
                      </NavLink>
                    </NavItem>
                    )}
                  </Nav>
                  <TabContent activeTab={currentTab}>
                    <TabPane tabId="overall">
                      {currentTab === "overall" && (
                        <AllTimeCompanyStats container={container} />
                      )}
                    </TabPane>
                    <TabPane tabId="period">
                      {currentTab === "period" && (
                        <MonthlyCompanyStatsInnerComponent
                          period={period}
                          company={company}
                          container={container}
                          enableNavigation={true}
                          detailedMembersStats={true}
                          detailedJobsStats={true}
                          showAggregatedStats={true}
                          showAggregatedJobsChart={true}
                        ></MonthlyCompanyStatsInnerComponent>
                      )}
                    </TabPane>
                    <TabPane tabId="members">
                      {currentTab === "members" && (
                        <CompanyMemberStats
                          company={company}
                          container={container}
                        ></CompanyMemberStats>
                      )}
                    </TabPane>
                    <TabPane tabId="vehicles">
                      {currentTab === "vehicles" && (
                        <VehicleStats container={container}></VehicleStats>
                      )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
            {!container.dataService.data.enablePremiumFeature() && (
              <aside className="ad-column-placeholder">
                {!window.overwolf && (
                  <BoxDynamicAd container={container} className="my-3" />
                )}
              </aside>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default MonthlyCompanyStats;
